export default function convertFromSquareKmToAcre(value) {
    return value * 247.105
}